<style scoped>
.v-radio i {
  margin-top: 24px !important;
}
</style>

<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>
          {{ $tc('models.quote', 1) }}
        </h1>
      </v-flex>

      <v-flex xs12 sm12 md4>
        <v-form @submit.prevent="submit">
          <v-card>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="quote.origin_postal_code"
                    :label="$t('attrs.origin_postal_code')"
                    v-validate="'required'"
                    :error-messages="errors.collect('origin_postal_code')"
                    data-vv-name="origin_postal_code"
                    :data-vv-as="$tc('attrs.origin_postal_code')"
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <v-autocomplete
                    v-model="quote.origin_country_id"
                    :items="countries"
                    item-value="id"
                    item-text="name"
                    :label="$tc('originCountry')"
                    v-validate="'required'"
                    :error-messages="errors.collect('country_id')"
                    data-vv-name="country_id"
                    :data-vv-as="$tc('models.country')"
                    browser-autocomplete="hydra-new-password"
                    required
                    :disabled="loading"
                  ></v-autocomplete>
                </v-flex>

                <v-flex xs12>
                  <v-text-field
                    v-model="quote.destination_postal_code"
                    :label="$t('attrs.destination_postal_code')"
                    v-validate="'required'"
                    :error-messages="errors.collect('destination_postal_code')"
                    data-vv-name="destination_postal_code"
                    :data-vv-as="$tc('attrs.destination_postal_code')"
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <v-autocomplete
                    v-model="quote.destination_country_id"
                    :items="countries"
                    item-value="id"
                    item-text="name"
                    :label="$tc('destinationCountry')"
                    v-validate="'required'"
                    :error-messages="errors.collect('country_id')"
                    data-vv-name="country_id"
                    :data-vv-as="$tc('models.country')"
                    browser-autocomplete="hydra-new-password"
                    required
                    :disabled="loading"
                  ></v-autocomplete>
                </v-flex>

                <v-flex xs12 sm12 md6>
                  <v-text-field
                    v-model="quote.length"
                    :label="$t('attrs.length') + ' CM'"
                    v-validate="'required|decimal|min_value:1'"
                    :error-messages="errors.collect('length')"
                    data-vv-name="length"
                    :data-vv-as="$t('attrs.length')"
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm12 md6>
                  <v-text-field
                    v-model="quote.width"
                    :label="$t('attrs.width') + ' CM'"
                    v-validate="'required|decimal|min_value:1'"
                    :error-messages="errors.collect('width')"
                    data-vv-name="width"
                    :data-vv-as="$t('attrs.width')"
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm12 md6>
                  <v-text-field
                    v-model="quote.height"
                    :label="$t('attrs.height') + ' CM'"
                    v-validate="'required|decimal|min_value:1'"
                    :error-messages="errors.collect('height')"
                    data-vv-name="height"
                    :data-vv-as="$t('attrs.height')"
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm12 md6>
                  <v-text-field
                    v-model="quote.weight"
                    :label="$t('attrs.weight') + ' KG'"
                    v-validate="'required|decimal|min_value:1'"
                    :error-messages="errors.collect('weight')"
                    data-vv-name="weight"
                    :data-vv-as="$t('attrs.weight')"
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <v-select v-model="quote.parcel_type"
                    :items="parcelTypes"
                    item-value="id"
                    item-text="name"
                    :label="$t('attrs.parcel_type')"
                    :error-messages="errors.collect('parcel_type')"
                    required
                  ></v-select>
                </v-flex>

                <p v-if="volumetricWeight">
                  {{ $t('volumetricWeight') }}:
                  <strong>{{ volumetricWeight }}</strong>
                </p>

                <v-flex xs12 class="text-xs-right">
                  <v-btn color="default" @click="createShipment" :disabled="!selectedRate"> {{ $t('createShipment') }} </v-btn>
                  <v-btn color="primary" dark :loading="loading" :disabled="loading" type="submit">{{ $t('quoteNow') }}</v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-form>
      </v-flex>

      <v-flex xs12 sm12 md8>
        <v-data-table class="elevation-1"
                      :items="rates"
                      :loading="loading"
                      hide-headers
                      hide-actions
                      :no-data-text="noDataText">
          <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>

          <template v-slot:items="props">
            <tr :active="selectedRate === props.item" @click="selectedRate = props.item">
              <td width="5%">
                <v-radio-group v-model="selectedRate">
                  <v-radio :value="props.item" />
                </v-radio-group>
              </td>
              <td>
                <img :src="props.item.image.url" :alt="props.item.carrier_name" width="100" />
              </td>
              <td>
                {{ props.item.service_name }}
                <span class="error--text" v-if="props.item.extended_zone">
                  ({{ $t('attrs.extended_zone') }})
                </span>
              </td>
              <td> {{ props.item.days }} {{ $t('attrs.days') }} </td>

              <RateCosts :rate="props.item" :isOperatorAdminRates="isOperatorAdminRates"></RateCosts>
            </tr>
          </template>
        </v-data-table>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import Quote from '@/client/quote'
import Setting from '@/client/setting'
import Country from '@/client/country'

import RateCosts from '@/components/RateCosts'

export default {
  name: 'QuoteFormView',

  props: {},

  data () {
    return {
      headers: [
        { text: '', align: 'left', sortable: false, value: '', width: '110' },
        { text: this.$tc('models.service'), align: 'left', sortable: true, value: 'service_name' },
        { text: this.$t('delivery_time'), align: 'left', sortable: true, value: 'delivery_time' },
        { text: this.$t('cost'), align: 'left', sortable: true, value: 'total' }
      ],
      parcelTypes:[
        { id: 'box', name: this.$t('list.parcelTypes.box') },
        { id: 'doc', name: this.$t('list.parcelTypes.doc') },
        { id: 'ltl', name: this.$t('list.parcelTypes.ltl') }
      ],
      rates: [],
      loading: false,
      selectedRate: null,
      quote: {
        parcel_type: 'box'
      },
      settings: [],
      countries: [],
      originCountries: [],
      volumetricWeight: '',
      isOperatorAdminRates: false
    }
  },

  components: {
    RateCosts,
  },

  computed: {
    showDiscount () {
      if (!this.settings) { return }

      const setting = this.settings.find(o => o.key === 'show_discount') || {}
      return setting.value === '1'
    },

    noDataText () {
      if (this.loading && !this.rates.length) {
        return this.$t('loading')
      }

      if (!this.loading && !this.rates.length) {
        return this.$t('noDataAvailable')
      }

      return ""
    },
  },

  methods: {
    async submit () {
      const isValid = await this.$validator.validateAll()
      if (!isValid) { return }

      this.loading = true
      try {
        this.rates = await this.quote.save()
        if (this.rates[0]) {
          this.volumetricWeight = this.rates[0].volumetric_weight
        }
      } catch (err) {
        this.handleErr(err)
      }
      this.loading = false
    },

    createShipment () {
      this.quote.selectedRate = this.selectedRate
      window.sessionStorage.setItem('new_shipment', JSON.stringify(this.quote))
      this.goTo('newShipment')
    }
  },

  watch: {
  },

  async mounted () {
    this.quote = new Quote({ parcel_type: 'box' })
    this.settings = await Setting.all()
    const operatorSetting = this.settings.find(o => o.key === 'operator_visible_rates') || {}
    this.isOperatorAdminRates = operatorSetting.value == '1'

    this.countries = await Country.all({ per_page: 2000, order: 'name ASC', fast_search: true })
    const country = this.countries.find(o => o.code === 'MX')
    if (country) {
      this.quote.origin_country_id = country.id
      this.quote.destination_country_id = country.id
    }
  }
}
</script>
